import { useContext } from 'react'
import { FormsContext, IFormsContext } from '../providers/FormsProvider'

export default function useForms(): IFormsContext {
  return useContext(FormsContext)
}
